import {SupportedLocales} from '#types/locale.js';

export const ssoLanguage = {
  [SupportedLocales.EN]: {
    general: {
      loginUrl: 'Login Url',
      save: 'Save',
      title: 'SSO Settings',
      subtitle:
        'Setup and configure your SSO settings to allow your users to log in to the GrowthLoop app using their own credentials. As well as, map your IdP groups to GrowthLoop teams and roles.',
    },
    modal: {
      title: 'Enable SSO',
      subtitle:
        'Enable your SSO by creating an application for the SAML connection in two steps',
      steps: {
        step1:
          'Create your SAML connection on your identity provider (eg, Okta), using the information below:',
        step2: 'Provide the following details after step 1 above',
      },
      static: {
        clientId: 'Client ID',
        clientName: 'client-name',
        replyUrl: 'Reply URL',
        signOnUrl: 'Sign-on URL',
        logoutUrl: 'Logout URL',
        trustedOrigins: 'Trusted Origins',
        contactArchitect:
          'Contact your Solutions Architect at GrowthLoop with the following details to set up your SSO:',
      },
      form: {
        yourLoginUrl: 'Your login URL is',
        signInUrl: 'Sign in URL',
        x509Certificate: 'X509 Signing Certificate',
      },
      actions: {
        save: 'Save',
        cancel: 'Cancel',
      },
    },
    enabled: {
      header: {
        message: 'SSO is enabled for your organization.',
        action: {
          label: 'Configure SSO',
        },
      },
    },
    disabled: {
      header: {
        message: 'SSO is not set up or configured for your organization.',
        action: {
          label: 'Enable SSO',
        },
      },
    },
    mapping: {
      role: {
        title: 'Team and Role Mapping',
        subtitle:
          "Map your IdP's (Identity Provider) groups to GrowthLoop teams and roles",
      },
      default: {
        title: 'Default Group Mappings',
        teamAndRolePrefix:
          'If your users are not mapped through the above mapping, they can be automatically assigned to any team in your organization and assume any role. You can provide a default team and role below, or leave both blank (both must be blank or both must be filled).',
        teamSelectLabel: 'Which team would you like to assign them to?',
        roleSelectLabel: 'Which role would you like to assign them to?',
        placeholder: 'Do not assign',
      },
    },
  },
  [SupportedLocales.ES]: {
    general: {
      loginUrl: 'URL de inicio de sesión',
      save: 'Guardar',
      title: 'Configuración de SSO',
      subtitle:
        'Configura y habilita tu SSO para permitir que tus usuarios inicien sesión en la app GrowthLoop usando sus propias credenciales. Así como, asigna tus grupos del IdP a equipos y roles de GrowthLoop.',
    },
    modal: {
      title: 'Habilitar SSO',
      subtitle:
        'Habilita tu SSO creando una aplicación para la conexión SAML en dos pasos',
      steps: {
        step1:
          'Crea tu conexión SAML en tu proveedor de identidad (por ejemplo, Okta), usando la información a continuación:',
        step2:
          'Proporciona los siguientes detalles después de completar el paso 1:',
      },
      static: {
        clientId: 'ID del cliente',
        clientName: 'nombre-cliente',
        replyUrl: 'URL de respuesta',
        signOnUrl: 'URL de inicio de sesión',
        logoutUrl: 'URL de cierre de sesión',
        trustedOrigins: 'Orígenes de confianza',
        contactArchitect:
          'Contacta a tu arquitecto de soluciones en GrowthLoop con los siguientes detalles para configurar tu SSO:',
      },
      form: {
        yourLoginUrl: 'Tu URL de inicio de sesión es',
        signInUrl: 'URL de inicio de sesión',
        x509Certificate: 'Certificado de firma X.509',
      },
      actions: {
        save: 'Guardar',
        cancel: 'Cancelar',
      },
    },
    enabled: {
      header: {
        message: 'SSO está habilitado para tu organización.',
        action: {
          label: 'Configurar SSO',
        },
      },
    },
    disabled: {
      header: {
        message: 'SSO no está configurado o habilitado para tu organización.',
        action: {
          label: 'Habilitar SSO',
        },
      },
    },
    mapping: {
      role: {
        title: 'Asignación de equipos y roles',
        subtitle:
          'Asigna los grupos del proveedor de identidad (IdP) a los equipos y roles de GrowthLoop',
      },
      default: {
        title: 'Asignación de grupos por defecto',
        teamAndRolePrefix:
          'Si tus usuarios no están asignados a través de la asignación anterior, se les podrá asignar automáticamente a cualquier equipo en tu organización y podrán asumir cualquier rol. Puedes proporcionar un equipo y rol por defecto a continuación, o dejar ambos en blanco (ambos deben estar en blanco o ambos deben estar llenos).',
        teamSelectLabel: '¿A qué equipo te gustaría asignarlos?',
        roleSelectLabel: '¿Qué rol te gustaría asignarles?',
        placeholder: 'No asignar',
      },
    },
  },
};
